<template>
    <div class="ad-container" v-if="visible">
        <div class="ad-mask"></div>
        <div class="ad-content-box">
            <i class="el-icon-close" @click="handleAdClose"></i>
            <el-carousel :interval="interval" trigger="click">
                <el-carousel-item v-for="(item, index) in list" :key="item.src+ '-' +index">
<!--
                    <a :href="item.url" target="_blank" @click="handleImgClick(item)">
-->
                        <img v-real-img="item.image" :src="defaultImgSrc" :alt="item.caption">
                    <!--</a>-->
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>
    /**
     * 检测图片是否存在
     * @param url
     */
    let imageIsExist = function(url) {
        return new Promise((resolve) => {
            let img = new Image();
            img.onload = function () {
                if (this.complete == true){
                    resolve(true);
                    img = null;
                }
            };
            img.onerror = function () {
                resolve(false);
                img = null;
            };
            img.src = url;
        });
    };
    import defaultImg from '@/assets/img/img_default.png';
    export default {
        name: "AdBanner",
        props: {
            interval: {
                type: [Number, String],
                default: 3000
            },

            visible: {
                type: Boolean,
                default: false,
            },

            list: {
                type: Array,
                default: function () {
                    return [];
                },
            },
        },

        data () {
            return {
                defaultImgSrc: defaultImg,
            };
        },

        directives: {
            realImg: {
                bind: async function (el, binding) {
                    let imgURL = binding.value;
                    if (imgURL) {
                        let exist = await imageIsExist(imgURL);
                        if (exist) {
                            el.setAttribute('src', imgURL);
                        }
                    }
                },
            }
        },

        methods: {
            handleAdClose () {
                console.log('关闭广告栏');
                this.$emit("close", false);
            },

            handleImgClick (img) {
                console.log('点击图片 %o', img);
            },

        },

        mounted () {
            console.log('ad-banner mounted');
        },

        created () {

        },
    }
</script>

<style lang="less" scoped>
    .ad-container {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;

        .ad-mask {
            position: absolute;
            width: 100%;
            height: 100%;
            background-color: rgba(51, 51, 51, .4);
            top: 0;
            left: 0;
        }

        .ad-content-box {
            position: absolute;
            width: 980px;
            height: 410px;
            top: 50%;
            left: 50%;
            margin-top: -205px;
            margin-left: -490px;
        }
    }
</style>

<style lang="less">

    .ad-container {

        .ad-content-box {

            i.el-icon-close {
                position: absolute;
                z-index: 999;
                top: 25px;
                right: 25px;
                font-size: 25px;
                font-weight: 500;
                color: #FFF;
            }

            i.el-icon-close:hover {
                cursor: pointer;
            }

            .el-carousel__container {
                height: 410px !important;
            }

            .el-carousel__item img {
                width: 100%;
                height: 100%;
            }
        }

    }

</style>
